import { render, staticRenderFns } from "./CartTrigger.vue?vue&type=template&id=464ef9a1&"
import script from "./CartTrigger.vue?vue&type=script&lang=js&"
export * from "./CartTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports